import { Card, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { RegisteredStudentData } from "../AdminSingleEventPage";
import { ClassyearChart } from "./Charts";
import { StyledHr } from "./style";

const { Text } = Typography;

interface Props {
  registeredStudents: RegisteredStudentData[];
}
export interface ClassYearDistributionData {
  classYear: string;
  amount: number;
}

const ClassYearDistribution: React.FC<Props> = ({ registeredStudents }) => {
  const [classYearDistribution, setClassYearDistribution] = useState<ClassYearDistributionData[]>([]);

  useEffect(() => {
    const distributionData: ClassYearDistributionData[] = Object.entries(
      registeredStudents.reduce((acc, student) => {
        acc[student.year_level] = (acc[student.year_level] || 0) + 1;
        return acc;
      }, {} as Record<string, number>)
    ).map(([classYear, amount]) => ({ classYear, amount }));

    setClassYearDistribution(distributionData);
  }, [registeredStudents]);

  return (
    <>
      <Card title="Påmeldte fordelt på årstrinn" style={{ height: "100%", width: "100%" }}>
        <ClassyearChart classYears={classYearDistribution} />
        <Row gutter={10} style={{ marginTop: "10px" }}>
          <Col span={14}>
            <Text strong>Årstrinn</Text>
          </Col>
          <Col span={5}>
            <Text strong>Antall</Text>
          </Col>
          <Col span={5}>
            <Text strong>Andel</Text>
          </Col>
        </Row>
        <StyledHr />
        {classYearDistribution.map(({ classYear, amount }) => (
          <div key={classYear}>
            <Row gutter={10}>
              <Col span={14}>{classYear}</Col>
              <Col span={5}>{amount}</Col>
              <Col span={5}>{((amount / registeredStudents.length) * 100).toFixed(1)}%</Col>
            </Row>
            <StyledHr />
          </div>
        ))}
      </Card>
    </>
  );
};

export default ClassYearDistribution;
